import React from 'react';
import { Helmet } from 'react-helmet-async';

const HomeStructuredData: React.FC = () => {
  // Structured data for the homepage
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "TourismBusiness",
    "name": "Cats About Town Tours",
    "description": "Explore New York's feline history with Cats About Town Tours. Join our unique walking tours to discover the cats that shaped NYC.",
    "url": "https://catsabouttowntours.com/",
    "logo": "/lovable-uploads/a7814c71-1569-43b8-8a9c-e24f811be427.png",
    "foundingDate": "2024",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "New York",
      "addressRegion": "NY",
      "addressCountry": "US"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "NYC Cat History Walking Tours",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "TouristTrip",
            "name": "Brooklyn Heights Cat Tour",
            "description": "Discover the historic cats of Brooklyn Heights in this 90-minute walking tour",
            "duration": "PT90M",
            "price": "40",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock",
            "image": "/lovable-uploads/0a57130d-68ab-4a75-b052-cfeffcf79b78.png",
            "location": {
              "@type": "Place",
              "name": "Brooklyn Heights",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Brooklyn",
                "addressRegion": "NY",
                "addressCountry": "US"
              }
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "TouristTrip",
            "name": "Financial District Cat Tour",
            "description": "Explore the feline history of NYC's financial center",
            "duration": "PT90M",
            "price": "40",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock",
            "image": "/lovable-uploads/93adf40c-ae90-4c69-8b73-4748c9db8a0e.png",
            "location": {
              "@type": "Place",
              "name": "Financial District",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "New York",
                "addressRegion": "NY",
                "addressCountry": "US"
              }
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "TouristTrip",
            "name": "Lower East Side Cat Tour",
            "description": "Learn about immigrant cats and their impact on NYC's Lower East Side",
            "duration": "PT90M",
            "price": "40",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock",
            "image": "/lovable-uploads/d50c44ab-fa90-46fd-9421-79e3007adbe0.png",
            "location": {
              "@type": "Place",
              "name": "Lower East Side",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "New York",
                "addressRegion": "NY",
                "addressCountry": "US"
              }
            }
          }
        }
      ]
    },
    "review": {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Person",
        "name": "Sarah from Chicago"
      },
      "reviewBody": "I never knew cats played such a big role in NYC history! Peggy's passion was infectious, and I learned so many fascinating stories. This was the highlight of my trip to New York."
    },
    "sameAs": [
      "https://www.instagram.com/catsabouttowntours/",
      "https://www.facebook.com/catsabouttowntours/"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "150",
      "bestRating": "5",
      "worstRating": "1"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Saturday", "Sunday"],
      "opens": "10:00",
      "closes": "16:00"
    },
    "priceRange": "$40",
    "areaServed": {
      "@type": "City",
      "name": "New York",
      "containedIn": {
        "@type": "State",
        "name": "New York"
      }
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-555-0123",
      "contactType": "customer service",
      "email": "info@catsabouttowntours.com",
      "availableLanguage": ["English"]
    },
    "image": [
      "/lovable-uploads/f0cb5bcd-d58d-44ab-9619-011f839bec4f.png",
      "/lovable-uploads/e100a577-5b2e-45e7-8c5a-045a615b98ba.png",
      "/lovable-uploads/cf69d03b-6e71-43d3-936d-5465eaa5212f.png"
    ],
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://catsabouttowntours.com/"
    },
    "potentialAction": {
      "@type": "ReserveAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://catsabouttowntours.com/booking",
        "inLanguage": "en-US",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default HomeStructuredData;
